export default {
  EXTEND_GROUP_BOOKINGS_CANDIDATE_UNAVAILABLE:
    'extend_group_bookings_candidate_unavailable',
  EXTEND_GROUP_BOOKING_GROUP_RANGE_TOO_LARGE:
    'extend_group_booking_group_range_too_large',
}
